import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=6e0416f4&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=js&"
export * from "./ColumnList.vue?vue&type=script&lang=js&"
import style0 from "./ColumnList.vue?vue&type=style&index=0&id=6e0416f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0416f4",
  null
  
)

export default component.exports